<script lang="ts">
	export let height: number
</script>

<div class="col-span-12 row-start-1 hidden w-full md:block" style="height: {height}rem" />
<div class="col-span-12 row-start-1 block w-full md:hidden" style="height: {height / 2}rem" />
